import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getCountries, type CountryConfig } from "@/shared/config/countries";

/**
 * Hook that loads countries from DB and provides a helper to get display name by code.
 * Use for consistent country display across the app (names from countries_config).
 */
export function useCountries() {
  const { i18n } = useTranslation();
  const [countries, setCountries] = useState<CountryConfig[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCountries()
      .then(setCountries)
      .catch(() => setCountries([]))
      .finally(() => setLoading(false));
  }, []);

  const getCountryName = useCallback(
    (code: string): string => {
      const c = countries.find((x) => x.code === code);
      return c ? (i18n.language === "es" ? c.nameEs : c.nameEn) : code;
    },
    [countries, i18n.language]
  );

  return { countries, loading, getCountryName };
}
